module.exports = __webpack_public_path__ + "img/no-signature.d29e23e6.svg";